import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdjustmentsModel } from 'src/app/commission/adjustments/adjustments.model';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { CallDetails } from 'src/app/models/commission/call-details.model';
import { FreeForm } from 'src/app/models/commission/free-form.model';
import { KomFeed } from 'src/app/models/commission/kom-feed.model';
import { Kpimaster } from 'src/app/models/commission/kpimaster.model';
import { MobileFeedModel } from 'src/app/models/commission/mobile-feed.model';
import { RegionsModel } from 'src/app/models/manageRegions/regions.model';
import { UpdateManualDataModel } from 'src/app/models/upload/update_manual_data.model';
import { CommissionService } from 'src/app/service/commission.service';
import { GlobalService } from 'src/app/service/global.service';
import { KomFeedService } from 'src/app/service/komfeed.service';
import { ManageRegionsService } from 'src/app/service/manage-regions.service';
import { NotificationService } from 'src/app/service/notification.service';
import { UpdateManualDataService } from 'src/app/service/update-manual-data.service';

@Component({
  selector: 'app-update-manual-data',
  templateUrl: './update-manual-data.component.html',
  styleUrls: ['./update-manual-data.component.css']
})
export class UpdateManualDataComponent implements OnInit {
  public goalsUpdateModel = new UpdateManualDataModel();
  public kpisList: UpdateManualDataModel[] = [];
  public complansList: UpdateManualDataModel[] = [];
  public calrunidsList: UpdateManualDataModel[] = [];
  public isAdjustments: boolean = true;
  public isGoals: boolean = false;
  public adjustmentResultList: UpdateManualDataModel[] = [];
  public goalsResultList: UpdateManualDataModel[] = [];


  constructor(private komFeedService: KomFeedService, private commissionService: CommissionService, private datePipe: DatePipe,
    private router: Router, private notificationService: NotificationService, private manageRegionsService: ManageRegionsService,
    private httpService: HttpClient, private updateManualDataService: UpdateManualDataService, private globalService: GlobalService) { }


  ngOnInit(): void {
    this.getCalRunIds();
    this.getCommPlans();
    this.getKpis();
    

    this.goalsUpdateModel.type = localStorage.getItem('update_type');
    this.goalsUpdateModel.cal_run_id = localStorage.getItem('update_calrunid');
    this.goalsUpdateModel.comm_plan_id = Number(localStorage.getItem('update_commplanid'));
    this.goalsUpdateModel.kpi_id = Number(localStorage.getItem('update_kpiid'));


  }

  getCalRinId(event: any) {
    console.log(event.currentTarget.value);

  }

  getCommPlanId(event: any) {
    console.log(event.currentTarget.value);

  }

  getKpiId(event: any) {
    console.log(event.currentTarget.value);

  }

  search() {
    console.log("search() called = " + this.goalsUpdateModel.type);
    if (this.goalsUpdateModel.type === "Adjustments") {
      this.searchAdjustmentResults();
    } if (this.goalsUpdateModel.type === "Goals") {
      this.searchGoalsResults()
    }
  }

  searchAdjustmentResults() {
    console.log("searchAdjustmentResults() called");
    if (!this.goalsUpdateModel.type) {
      this.notificationService.sendNotification(NotificationType.WARNING, 'Please select Type');
    } else if (!this.goalsUpdateModel.cal_run_id) {
      this.notificationService.sendNotification(NotificationType.WARNING, 'Please Select Cal Run ID');
    } else if (!this.goalsUpdateModel.comm_plan_id) {
      this.notificationService.sendNotification(NotificationType.WARNING, 'Please Select Commission Plan');
    } else {

      console.log(this.goalsUpdateModel.type);

      if (!this.goalsUpdateModel.kpi_id) {
        this.goalsUpdateModel.kpi_id = 0;
      }

      // console.log(this.goalsUpdateModel);
      this.updateManualDataService.searchAdjustmentResults(this.goalsUpdateModel).
        subscribe((data: UpdateManualDataModel[]) => {
          this.adjustmentResultList = data;
          // console.log(JSON.stringify(this.adjustmentResultList));
          this.updateManualDataService.updateManualDataModel = this.goalsUpdateModel;

          localStorage.setItem('update_type', this.goalsUpdateModel.type);
          localStorage.setItem('update_calrunid', this.goalsUpdateModel.cal_run_id.toString());
          localStorage.setItem('update_commplanid', this.goalsUpdateModel.comm_plan_id.toString());

          // console.log(this.goalsUpdateModel.kpi_id);
          if (this.goalsUpdateModel.kpi_id !== 0) {
            // console.log("Inside IF");
            localStorage.setItem('update_kpiid', this.goalsUpdateModel.kpi_id.toString());
          } else {
            localStorage.setItem('update_kpiid', "");
          }


          if (this.adjustmentResultList?.length > 0)
            this.router.navigate(['/update-adjustment-results']);
          else
            this.notificationService.sendNotification(NotificationType.WARNING, 'No Records Found');
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
    }
  }

  searchGoalsResults() {
    console.log("searchGoalsResults() called");
    if (!this.goalsUpdateModel.type) {
      this.notificationService.sendNotification(NotificationType.WARNING, 'Please select Type');
    } else if (!this.goalsUpdateModel.cal_run_id) {
      this.notificationService.sendNotification(NotificationType.WARNING, 'Please Select Cal Run ID');
    } else if (!this.goalsUpdateModel.comm_plan_id) {
      this.notificationService.sendNotification(NotificationType.WARNING, 'Please Select Commission Plan');
    } else {

      if (!this.goalsUpdateModel.kpi_id) {
        this.goalsUpdateModel.kpi_id = 0;
      }

      // console.log(this.goalsUpdateModel);
      this.updateManualDataService.searchGoalsResults(this.goalsUpdateModel).
        subscribe((data: UpdateManualDataModel[]) => {
          this.goalsResultList = data;
           console.log(JSON.stringify(this.goalsResultList));
          this.updateManualDataService.updateManualDataModel = this.goalsUpdateModel;

          console.log(this.goalsUpdateModel.type);
          localStorage.setItem('update_type', this.goalsUpdateModel.type);
          localStorage.setItem('update_calrunid', this.goalsUpdateModel.cal_run_id.toString());
          localStorage.setItem('update_commplanid', this.goalsUpdateModel.comm_plan_id.toString());

           console.log(this.goalsUpdateModel.kpi_id);
          if (this.goalsUpdateModel.kpi_id !== 0) {
             console.log("Inside IF");
            localStorage.setItem('update_kpiid', this.goalsUpdateModel.kpi_id.toString());
          } else {
            localStorage.setItem('update_kpiid', "");
          }

          if (this.goalsResultList?.length > 0)
            this.router.navigate(['/update-goal-results']);
          else
            this.notificationService.sendNotification(NotificationType.WARNING, 'No Records Found');
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
    }
  }

  checkType() {
    console.log("checkType() called = " + this.goalsUpdateModel.type);
    if (this.goalsUpdateModel.type === 'Adjustments') {
      this.isAdjustments = true;
      this.isGoals = false;
    } else if (this.goalsUpdateModel.type === 'Goals') {
      this.isAdjustments = false;
      this.isGoals = true;
    }
    this.getKpis();
  }

  public getCalRunIds(): void {
    console.log("getActiveCorps called");
    this.updateManualDataService.getCalRunIds().subscribe(
      (response: UpdateManualDataModel[]) => {
        this.calrunidsList = response;
        this.calrunidsList = this.calrunidsList.filter((v, i) => this.calrunidsList.findIndex(item => item.calrunid == v.calrunid) === i);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  public getCommPlans(): void {
    console.log("getCommPlans called");
    this.updateManualDataService.getCommPlans().subscribe(
      (response: UpdateManualDataModel[]) => {
        this.complansList = response;
        // console.log(this.complansList);
        this.complansList = this.complansList.filter((v, i) => this.complansList.findIndex(item => item.commplanid == v.commplanid) === i);
        // console.log(this.complansList);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  public getKpis(): void {
    console.log("getKpis called");
   // console.log(this.goalsUpdateModel.type);
    if(!this.goalsUpdateModel.type){
      this.goalsUpdateModel.type = localStorage.getItem('update_type');
    }
    
    this.updateManualDataService.getKpis(this.goalsUpdateModel.type).subscribe(
      (response: UpdateManualDataModel[]) => {
        this.kpisList = response;
        //console.log(JSON.stringify(this.kpisList));
        this.kpisList = this.kpisList.filter((v, i) => this.kpisList.findIndex(item => item.kpiid == v.kpiid) === i);
        //console.log(this.kpisList);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }


  resetFields() {
    this.goalsUpdateModel.type = null;
    this.goalsUpdateModel.calrunid = null;
    this.goalsUpdateModel.commplanid = null;
    this.goalsUpdateModel.kpiid = null;
  }
}

